
import { i18nText } from '@/locales';
import { UsersUpdateRequestType } from '@/entity/Settings/Users';
import { phone } from "@/utils/validators/rules.ts";

export class UserFormData {
    public id: number | null;
    public name: string;
    public role_id: number | null;
    public phone: string;
    public email: string;
    public user_info: string;
    public password: string;
    public studios: Array<number>;

    setFormData(data: UsersUpdateRequestType): void {
        this.id = data.id;
        this.name = data.name;
        this.password = data.password;
        this.email = data.email;
        this.user_info = data.user_info;
        this.studios = data.studios;
        this.role_id = data.role_id;
        this.phone = data.phone
    }
    constructor() {
        this.id = null
        this.name = '';
        this.password = '';
        this.email = '';
        this.user_info = '';
        this.studios = [];
        this.role_id = null;
        this.phone = '';
    }
}
export const FormRules = {
    studios: [{ required: true, message: i18nText("Пожалуйста укажите студию"), trigger: 'change' }],
    name: [{ required: true, message: i18nText("Пожалуйста укажите имя"), trigger: 'change' }],

    password: [
        { required: true, message: i18nText("Пароль обязателен"), trigger: 'blur' },
        { min: 8, max: 16, message: i18nText("Требования к паролю: длина 8-16 символов, использование латиницы, использование цифр!"), trigger: 'blur' },
    ],

    role_id: [{ required: true, message: i18nText("Пожалуйста выберите роль"), trigger: 'change' }],
    phone: [
        { required: true, message: i18nText("Пожалуйста укажите номер телефона"), trigger: 'change' },
        { validator: phone, message: i18nText("Введите корректный номер телефона") }
    ],
};
